<template>
  <div class="sku__item" :class="{'sku__item--invisible': !imgLoaded}">
    <router-link :to="routerTo()" class="inner">
      <img :src="shopifyImg(product.images[0].src)" v-if="product.images.length > 0" :alt="product.title" @load="imgLoaded = true">
      
      <!-- <template v-if="!isPurchase">
        <img :src="shopifyImg(product.images[0].src)" v-if="product.images.length > 0" :alt="product.title" @load="imgLoaded = true">
      </template>
      <template v-else>
        <div class="resp-wrapper">
          <img :src="shopifyImg(product.images[0].src)" v-if="product.images.length > 0" :alt="product.title" @load="imgLoaded = true" class="resp-image">
        </div>
      </template> -->
      
      <div class="h7 uppercase">
        <label>
          <div>
            <span>{{product.title}}</span><br>
            <span>{{product.variants[0].formattedPrice}}</span>
          </div>
        </label>
        <button class="view-item-btn"><span>Purchase Item</span></button>
      </div>
    </router-link>
  </div>
</template>

<script>
import Config from 'src/config'
import resizeShopifyImgUrl from 'assets/js/resizeShopifyImgUrl'
export default {
  name: 'Collection__SKUs__Item',
  props: ['product', 'viewName', 'isPurchase', 'collectionSlug'],
  data () {
    return {
      imgLoaded: false
    }
  },
  methods: {
    shopifyImg (url) {
      const size = window.innerWidth > Config.bkpt.mobile ? window.innerWidth / 3 * 1.6 : window.innerWidth * 1.6
      return resizeShopifyImgUrl(url, size)
    },
    routerTo () {
      // isPurchase
      if (this.isPurchase) {
        // e.g. /collections/knives/items/single-knife-set
        return `/collections/${this.collectionSlug}/items/${this.product.handle}`
      } else {
        return {name: this.viewName, params: {id: this.product.handle}}
        // return '/two'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

.resp-wrapper {
  height:0;
  padding-bottom:130%;
  position:relative !important;
}
.resp-image {
  position:absolute !important;
  top:0;
  left:0;
  width:100%;
  height:100%;
  object-fit:cover;
  // border: 1px red solid;
  background:pink;
  padding: 0 !important;
}
.sku__item{
  transition: opacity 500ms 100ms;
  &.sku__item--invisible{
    opacity:0;
  }
  // inner
  .inner{
    position: relative;
    display:block;
    img {
      width:100%;
      min-height:100%;
    }
    // card
    > div{
      position: absolute;
      bottom:0; left:0;
      width:100%;
      background-color:rgba(255,255,255,.85);
      transition: opacity 300ms 100ms;
      > *{
        display: flex;
        width:100%;
        align-items: center;
        justify-content: center;
        width:100%;
        min-height:(75/14)*1em;
        padding:$gutter;
      }
      > button{
        display: block;
        width:100%;
        background:$black;
        color:$white;
      }
    }
    // card on hover
    .no-touchevents &:hover > div{
      opacity:0;
      &:hover{
        opacity:1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Collection__SKUs__Item.vue?5b2695f2